import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'
import {checkPermTree,getNewRouter,filterAsyncRouter} from '@/router/permission'
import getPageTitle from '@/utils/get-page-title'
Vue.use(Router)


/* Layout */
import Layout from '@/layout'
import { localRead } from '@/utils/tools'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: 2
  },
  {
    path: '/',
    component:() => import('@/views/commonPage/index'),
    // meta: { title: '首页', icon: 'dashboard'},
    hidden:2,
  },
  {
    path: '/my',
    component:() => import('@/views/commonPage/index'),
    // meta: { title: '首页', icon: 'dashboard'},
    hidden:2,
    children:[
      {
        path: 'html',
        component: () => import('@/layout/index'),
        hidden: 2,
        children:[
          {
            path: '404',
            component:() => import('@/views/404.vue'),
            // meta: { title: '首页', icon: 'dashboard'},
            hidden:2,
          },
        ]
      },
    ]
  },
  {
    path: '*',
    redirect: '/my/html/404',
  },
]

export const asyncRoutes = [

  { path: '*', redirect: '/404', hidden: 2 }
]

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});
function routerGo(to, next,getRouter) {
  let routerReal = JSON.parse(JSON.stringify(getRouter))
  checkPermTree(routerReal) //递归将 path 中的 ?label 全部过滤掉
  getNewRouter(routerReal) //过滤菜单数据 从中得到最后的路由
  routerReal = filterAsyncRouter(routerReal) //过滤路由
  //routerReal.push({path:'*',component:Layout})
  router.addRoutes(routerReal) //动态添加路由
  next({ ...to, replace: true})

}

var getRouter;
router.beforeEach(async(to,form,next) =>{
   // set page title
   document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
 if(!getRouter){
  let router = localRead(to.query.label + '_router')
  if(to.query.label && router != null && router != undefined && router != ""){
      getRouter = JSON.parse(localRead(to.query.label + '_router'))
      routerGo(to,next,getRouter)
  }
 }else{
   next()
 }




  if(to.path === '/login'){
    next();
  }else{
    let hasToken;

    if(to.query.label == undefined){
      hasToken = localRead('sysToken')
    }else{
      hasToken = getToken(to.query.label)
    }
    if(hasToken === null || hasToken === ''){
      next('/login')
    }else{
      next();
    }
  }
})
export default router
